import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useTRPC } from '@/utils/trpc';

export const useDeleteDocumentAssessmentResultsTRPC = () => {
  const trpc = useTRPC();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    ...trpc.frontend.documentAssessmentResult.delete.mutationOptions({
      onSuccess: async () => {
        // COI-889: router-level key — the hand-listed set missed
        // `assessmentResultCount`, the Findings left-nav badge.
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.assessment.pathKey(),
        });
      },
    }),
  });

  return {
    deleteDocumentAssessmentResults: async (ids: string[]): Promise<void> => {
      await mutation.mutateAsync({ Ids: ids });
    },
    isLoading: mutation.isPending,
  };
};
